import ShoppingCartModal from '@/components/ShoppingCartModal';
import React from 'react';

type ShoppingCartProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ShoppingCart = ({ isModalOpen, setIsModalOpen }: ShoppingCartProps) => {
  return <>{isModalOpen && <ShoppingCartModal onClose={() => setIsModalOpen(false)} />}</>;
};

export default ShoppingCart;
